import { QueryString } from "./query-string";
import { singleton } from "tsyringe";

@singleton()
export class Platform {
  get(): string {
    const debugPlatform = QueryString.get("identity_icbm_app");
    if (debugPlatform) {
      return debugPlatform;
    }

    // Check for MediaWiki
    if (
      window.mw !== undefined &&
      window.ads?.context?.opts?.platformName !== undefined
    ) {
      return window.ads.context.opts.platformName;
    }

    return this.checkHostname();
  }

  private checkHostname(): string {
    const { hostname, pathname } = window.location;

    switch (true) {
      /// www.fandom.com, bingebot.fandom.com
      case hostname.includes("fandom"):
        return hostname.includes("bingebot") ? "bingebot" : "f2";
      // futhead.com
      case hostname.includes("futhead"):
        return "futhead";
      // muthead.com
      case hostname.includes("muthead"):
        return "muthead";
      // comicvine.gamespot.com, gamefaqs.gamespot.com, gamespot.com
      case hostname.includes("gamespot"):
        return hostname.includes("comicvine")
          ? "comicvine"
          : hostname.includes("gamefaqs")
          ? "gamefaqs"
          : "gamespot";
      // metcritic.com, metacritic.com/news
      case hostname.includes("metacritic"):
        return pathname.includes("news") ? "metacritic-neutron" : "metacritic";
      // tvguide.com
      case hostname.includes("tvguide"):
        return "tvguide";
      case hostname.includes("giantbomb"):
        return "giantbomb";
      case hostname.includes("fanatical"):
        return "fanatical";
      default:
        return "fandomdesktop";
    }
  }
}
